import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	Optional
} from "@angular/core";
import { CtaButtonMultipleSelectGroupControlComponent } from "../cta-button-multiple-select-group-control/cta-button-multiple-select-group-control.component";
import { CtaButtonMultipleSelectComponent } from "../cta-button-multiple-select/cta-button-multiple-select.component";

@Component({
    selector: "dodo-cta-button-multiple-select-group",
    templateUrl: "./cta-button-multiple-select-group.component.html",
    styleUrls: ["./cta-button-multiple-select-group.component.scss"],
    standalone: false
})
export class CtaButtonMultipleSelectGroupComponent implements OnInit {
	private __cards: CtaButtonMultipleSelectComponent[];
	private __activeCardId: string | number;
	private __inactiveCardId: string | number;

	@Input() set activeCardId(id: string | number) {
		this.__activeCardId = id;
		this.__updateCardStatus();
	}

	@Output() cardSelected = new EventEmitter<string | number>();
	@Output() cardUnSelected = new EventEmitter<string | number>();

	constructor(
		@Optional()
		private __featureCardsGroupControl: CtaButtonMultipleSelectGroupControlComponent
	) {
		this.__cards = [];
		if (this.__featureCardsGroupControl) {
			this.__featureCardsGroupControl.registerCardGroup(this);
		}
	}

	ngOnInit() {}

	addButton(card: CtaButtonMultipleSelectComponent) {
		card.active = card.id === this.__activeCardId;
		this.__cards.push(card);
	}

	removeButton(card: CtaButtonMultipleSelectComponent) {
		const cardIndex = this.__cards.map(c => c.id).indexOf(card.id);
		if (cardIndex >= 0) {
			this.__cards.splice(cardIndex, 1);
		}
	}

	registerActiveCard(cardId: string | number) {
		this.__activeCardId = cardId;
		this.cardSelected.emit(this.__activeCardId);
		this.__updateCardStatus();
	}

	registerInactiveCard(cardId: string | number) {
		this.__inactiveCardId = cardId;
		this.cardUnSelected.emit(this.__inactiveCardId);
		this.__updateCardStatus();
	}

	private __updateCardStatus() {
		this.__cards.forEach(c => {
			if (c.id === this.__activeCardId) {
				// c.updateActiveStatus(c.id === this.__activeCardId);
			}

		});
	}
}
